import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { PLACEHOLDER_AVATAR_RECTANGLE } from '@/const';

const Wrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  width: ${rem(34)};
  height: ${rem(54)};
  padding: 0 ${rem(5)};
`;

const Image = styled.img`
  width: ${rem(54)};
  height: ${rem(34)};
  transform: rotate(90deg) translate(10px, 10px);
  transform-origin: center;
  object-fit: cover;
`;

interface IProps {
  src: string;
  alt: string;
}

const AvatarRectangle = (props: IProps) => {
  const { src, alt } = props;

  return (
    <Wrapper>
      <Image src={src || PLACEHOLDER_AVATAR_RECTANGLE} alt={alt} loading="lazy" />
    </Wrapper>
  );
};

export default AvatarRectangle;
